<template>
    <template-page>
        <template #content>
            <div class="msg-error">
                <router-view />
            </div>
        </template>
    </template-page>
</template>

<script>
    import templatePage from '@/templates/page-panel-full'

    export default {
        components: { templatePage }
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>
